import styles from './CancelButton.module.css';

interface CancelButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const CancelButton = ({
  onClick,
  disabled = false,
}: CancelButtonProps) => (
  <button
    type="button"
    className={styles.cancelButton}
    onClick={onClick}
    disabled={disabled}
    aria-label="Cancel payment"
  >
    <span className={styles.label}>Cancel</span>
    <span className={styles.icon}>×</span>
  </button>
);
